import React from 'react';
import { Card as CardElement } from 'antd';
import { Card } from '../ntfSlice';
import { Col, Container, Row, Image } from 'react-bootstrap';
import { APIMEDIA_HOST } from '../../../conf/hosts'
import FooterButtons from '../../common/components/FooterButtons';
import styled from 'styled-components'

export interface INtfCardsReviewProps {
  hidden?: boolean
  level?: number
  cards?: Card[]
  doneReview: () => void
}


const CardMeta = styled(CardElement.Meta)`
  display: flex;
  justify-content: center; 
  align-items: center;
  height: 100%;
  margin-top: -60px;
  h2 strong {
    font-family: Helvetica, Arial, sans-serif;
    font-weight: bolder;
    font-size: 1.7rem;
  }
`


const NtfCardsReview = ({ hidden, level, cards, doneReview }: INtfCardsReviewProps) => {
  if (hidden || level === undefined || cards === undefined) { return null }

  const cardCols = cards.map((card, index) => {
    return (
      <Col xs={12} sm={6} md={4} lg={level === 1 && 3} key={`card-${index}`} className="mb-1">
        <CardElement 
          cover={
            <Image draggable={false} src={`${APIMEDIA_HOST}${card.card}`} fluid />
          }   
          style={{backgroundColor: "#EAF1FD", marginBottom: "20px"}}     
        >
          <CardMeta title={<h2><strong>{card.name}</strong></h2>} />
        </CardElement>
      </Col>
    )
  })
  
  return (
    <>
      <Container>
        <h4>Level {level}</h4>
        <p>Look carefully at each person so you will be able to identify the correct face with the correct name.  When you are finished looking at each person, click ‘Begin Exercise.’</p>
        <Row>
          <Col lg={level > 1 && {offset: 1, span: 10}}>
            <Row>
              {cardCols}
            </Row>
          </Col>
        </Row>
      </Container>
      <FooterButtons 
        buttons={[{ label: "Begin Exercise", action: doneReview, buttonType: "primary" }]}
      />
    </>
  )
}

export default NtfCardsReview